import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';

import { TextField, Stack, Label } from '@bingads-webui-react/fabric-control';
import { HelpPopupInline } from '@bingads-webui-react/help-popup';
import {
  thirdPartyMeasurementTrackingVendorField,
} from '../../model/campaign-third-party-vendor-setting';
import { AccountLinkedStatusLabel } from './account-linked-status-label';

const ISPOTConfig = ({ setting, i18n, setSetting }) => {
  const onChangeBrandId = (e, value) => {
    const updatedSetting = {
      ..._.omit(setting, 'indexInSettings'),
      [thirdPartyMeasurementTrackingVendorField.ISPOT_brandId]: value,
    };
    setSetting(updatedSetting);
  };

  const onRenderLabel = () => (
    <Stack verticalAlign="center" horizontal>
      <Label>
        {i18n.getString(_TL_('Brand ID'))}
      </Label>
      <HelpPopupInline topic="pop_BA_Measurement_BrandID" />
    </Stack>
  );

  return (
    <TextField
      className="ispot-brand-id"
      onRenderLabel={onRenderLabel}
      value={_.get(setting, thirdPartyMeasurementTrackingVendorField.ISPOT_brandId, '')}
      onChange={onChangeBrandId}
      ariaLabel={i18n.getString(_TL_('ISPOT Brand ID input'))}
      aria-required
    />
  );
};

const DVConfig = ({ i18n, doubleVerifyLinkEstablished }) => (
  <Stack
    verticalAlign="center"
    horizontal
    className="account-linked-status"
  >
    <AccountLinkedStatusLabel
      i18n={i18n}
      doubleVerifyLinkEstablished={doubleVerifyLinkEstablished}
    />
    { doubleVerifyLinkEstablished ?
      i18n.getString(_TL_('This measurement provider is activated for your account.'))
      : i18n.getString(_TL_('This measurement provider isn’t activated for your account.'))
    }
  </Stack>
);

export const customVendorConfigs = {
  ISPOT: ISPOTConfig,
  DV: DVConfig,
};

ISPOTConfig.propTypes = {
  setting: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  setSetting: PropTypes.func.isRequired,
};

DVConfig.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  doubleVerifyLinkEstablished: PropTypes.bool.isRequired,
};

